<template>
  <q-item clickable @click="view">
    <q-item-section avatar>
      <file-icon :file-name="fileName" />
    </q-item-section>
    <q-item-section>
      {{ fileName }}
    </q-item-section>
    <q-item-section side>
      <slot>
        <delete-file-btn
          v-if="canDelete"
          @deleted="$emit('deleted', $event)"
        />
      </slot>
    </q-item-section>
  </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import { RemoteFile } from '../type';
import {
  getFileName,
  isImage,
  isVideo,
  isObjectUrl,
} from '.';
import DeleteFileBtn from './DeleteFileBtn.vue';
import ViewFileModal from './ViewFileModal.vue';
import FileIcon from './FileIcon.vue';

export default defineComponent({
  emits: ['deleted'],
  components: { FileIcon, DeleteFileBtn },
  props: {
    file: {
      type: Object as () => RemoteFile,
      required: true,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fileName(): string {
      return getFileName(this.file) || 'No File Name';
    },
    isImage(): boolean {
      return isImage(this.file.url);
    },
    isVideo(): boolean {
      return isVideo(this.file.url);
    },
    isObjectUrl(): boolean {
      return isObjectUrl(this.file.url);
    },
    canView(): boolean {
      return (this.isImage || this.isVideo);
    },
  },
  methods: {
    view() {
      if (!this.canView) return;
      if (this.isImage || this.isVideo) {
        const props = { parent: this, file: this.file };
        openModal(ViewFileModal, props);
      } else if (!this.isObjectUrl) {
        window.location.href = this.file.url;
      }
    },
  },
});
</script>
